import SamplePage from "../Pages/Sample Page";
import Dashboard from "../Pages/Dashboard";
import UangMukaKegiatan from "../Pages/Uang Muka/UangMukaKegiatan";
import UangMukaOperasional from "../Pages/Uang Muka/UangMukaOperasional";
import AnggaranBulanan from "../Pages/AnggaranBulanan";
import DataTable from "../Pages/Tables/DataTable";
import ReactstrapTable from "../Pages/Tables/ReactstrapTable";
import ComingSoon from "../Pages/Coming Soon";
import TransaksiPages from "../Pages/Transaksi/TransaksiPages";
import SusulanGroup from "../Pages/Transaksi/SusulanGroup";
import BuatBaruGroup from "../Pages/Transaksi/BuatBaruGroup";
import BuatTransaksiPages from "../Pages/Transaksi/BuatTransaksiPages";
import PengaturanUnitKerja from "../Pages/Pengaturan/PengaturanUnitKerja";
import PengaturanUserRole from "../Pages/Pengaturan/PengaturanUserRole";
import PengaturanDaftarAkun from "../Pages/Pengaturan/PengaturanDaftarAkun";
import PengaturanSumberDana from "../Pages/Pengaturan/PengaturanSumberDana";
import PengaturanKegiatan from "../Pages/Pengaturan/PengaturanKegiatan";
import PengaturanJenisKegiatan from "../Pages/Pengaturan/PengaturanJenisKegiatan";
import PengaturanKategoriKegiatan from "../Pages/Pengaturan/PengaturanKategoriKegiatan";
import EditTransaksi from "../Component/Transaksi/containers/EditTransaksi";
import Realokasi from "../Pages/Realokasi";
import EditRealokasi from "../Component/Realokasi/containers/EditRealokasi";
import BuatRealokasi from "../Component/Realokasi/containers/BuatRealokasi";
import CreateUMK from "../Component/Uang Muka/UMK/containers/CreateUMK";
import UbahUMK from "../Component/Uang Muka/UMK/containers/UbahUMK";
import DaftarAkun from "../Pages/DaftarAkun";
import Laporan from "../Pages/Laporan";
import SystemLog from "../Pages/SystemLog";
import SKDokumen from "../Pages/SKDokumen";
import Panduan from "../Pages/Panduan";
import CapaianIK from "../Pages/Indikator/CapaianIK";
import EditCapaianIK from "../Component/Indikator/CapaianIK/containers/EditCapaianIK";
import CapaianSS from "../Pages/Indikator/CapaianSS";
import BuatCapaianSS from "../Component/Indikator/CapaianSS/BuatCapaianSS";
import EditCapaianSS from "../Component/Indikator/CapaianSS/EditCapaianSS";
import MailInbox from "../Pages/Email/Mail Inbox";
import ReadMail from "../Pages/Email/Read Mail";
// import Compose from '../Pages/Email/Compose';
import Calendar from "../Pages/Calendar";
import ProtectedUMK from "../Pages/Uang Muka/ProtectedUMK";
import BuatCapaianIK from "../Component/Indikator/CapaianIK/containers/BuatCapaianIK";
// import LoginAs from "../Pages/Login As/LoginAs";
// import OTP from "../Pages/Login As/OTP";

export const routes = [
  { path: `${process.env.PUBLIC_URL}/contoh`, Component: <SamplePage /> },
  // { path: `${process.env.PUBLIC_URL}/OTP`, Component: <OTP /> },
  // { path: `${process.env.PUBLIC_URL}/loginas`, Component: <LoginAs /> },
  { path: `${process.env.PUBLIC_URL}/email/mailbox`, Component: <MailInbox /> },
  {
    path: `${process.env.PUBLIC_URL}/email/:module/:moduleId`,
    Component: <ReadMail />,
  },
  // { path: `${process.env.PUBLIC_URL}/email/compose`, Component: <Compose /> },
  { path: `${process.env.PUBLIC_URL}/capaianik`, Component: <CapaianIK /> },
  {
    path: `${process.env.PUBLIC_URL}/capaianik/formcapaianik`,
    Component: <BuatCapaianIK />,
  },
  {
    path: `${process.env.PUBLIC_URL}/capaianik/editcapaianik/:capaianIKId`,
    Component: <EditCapaianIK />,
  },
  { path: `${process.env.PUBLIC_URL}/capaianss`, Component: <CapaianSS /> },
  {
    path: `${process.env.PUBLIC_URL}/capaianss/formcapaianss`,
    Component: <BuatCapaianSS />,
  },
  {
    path: `${process.env.PUBLIC_URL}/capaianss/editcapaianss/:capaianSSId`,
    Component: <EditCapaianSS />,
  },
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Dashboard /> },
  { path: `${process.env.PUBLIC_URL}/system-log`, Component: <SystemLog /> },
  { path: `${process.env.PUBLIC_URL}/faq`, Component: <ComingSoon /> },
  { path: `${process.env.PUBLIC_URL}/calendar`, Component: <Calendar /> },
  { path: `${process.env.PUBLIC_URL}/umk`, Component: <UangMukaKegiatan /> },
  {
    path: `${process.env.PUBLIC_URL}/umk/formumk`,
    Component: (
      <ProtectedUMK>
        <CreateUMK />
      </ProtectedUMK>
    )
  },
  {
    path: `${process.env.PUBLIC_URL}/umk/editumk/:formId`,
    Component: <UbahUMK />,
  },

  { path: `${process.env.PUBLIC_URL}/umo`, Component: <UangMukaOperasional /> },
  {
    path: `${process.env.PUBLIC_URL}/anggaran`,
    Component: <AnggaranBulanan />,
  },
  { path: `${process.env.PUBLIC_URL}/DataTabels`, Component: <DataTable /> },
  { path: `${process.env.PUBLIC_URL}/Tabels`, Component: <ReactstrapTable /> },
  {
    path: `${process.env.PUBLIC_URL}/realokasi`,
    Component: <Realokasi />,
  },
  {
    path: `${process.env.PUBLIC_URL}/realokasi/buatrealokasi`,
    Component: <BuatRealokasi />,
  },
  {
    path: `${process.env.PUBLIC_URL}/realokasi/edit/:formId`,
    Component: <EditRealokasi />,
  },
  {
    path: `${process.env.PUBLIC_URL}/daftarakun`,
    Component: <DaftarAkun />,
  },
  {
    path: `${process.env.PUBLIC_URL}/timeanggaran`,
    Component: <ComingSoon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/laporan`,
    Component: <Laporan />,
  },
  {
    path: `${process.env.PUBLIC_URL}/dokumen`,
    Component: <SKDokumen />,
  },
  {
    path: `${process.env.PUBLIC_URL}/panduan`,
    Component: <Panduan />,
  },
  {
    path: `${process.env.PUBLIC_URL}/aduan`,
    Component: <ComingSoon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/transaksi`,
    Component: <TransaksiPages />,
  },
  {
    path: `${process.env.PUBLIC_URL}/transaksi/:selectedComponent`,
    Component: <TransaksiPages />,
  },
  {
    path: `${process.env.PUBLIC_URL}/transaksi/buattransaksi`,
    Component: <BuatTransaksiPages />,
  },
  {
    path: `${process.env.PUBLIC_URL}/transaksi/edit/:formId`,
    Component: <EditTransaksi />,
  },
  {
    path: `${process.env.PUBLIC_URL}/transaksi/buatbarugroup`,
    Component: <BuatBaruGroup />,
  },
  {
    path: `${process.env.PUBLIC_URL}/transaksi/susulangroup`,
    Component: <SusulanGroup />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturanuserrole`,
    Component: <PengaturanUserRole />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturandaftarakun`,
    Component: <PengaturanDaftarAkun />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturansumberdana`,
    Component: <PengaturanSumberDana />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturankegiatan`,
    Component: <PengaturanKegiatan />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturanjeniskegiatan`,
    Component: <PengaturanJenisKegiatan />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturankategorikegiatan`,
    Component: <PengaturanKategoriKegiatan />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pengaturanunitkerja`,
    Component: <PengaturanUnitKerja />,
  },
];
